//pages
import Index from '@/views/pages/configuration/Index.vue'
import Reports from '@/views/apps/reports/Index.vue'
import layouts from '@/layout'

export default {
	path: 'reports',
	name: 'Informes',
	component: Index,
	redirect: { path: '/payment', name: 'payment' },
	icon: 'briefcase',
	auth: true,
	meta: {
		nav: true,
		roles: ['admin']
	},
	children: [
		{
			path: '/inventory',
			name: 'Inventario',
			component: Reports,
			meta: {
				nav: true,
        layout: layouts.navLeft,
        roles: ['admin'],
        icon: 'cash-register',
			}
		}
	]
}
